﻿import * as React from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from ".";
import { InformationTable } from "../../About";

export const AboutSection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => {
    const bindOnClick = (): void => {
        const aboutComponent: React.ReactNode = <InformationTable />;

        const activeProps: IActiveSectionProps = {
            moduleID: props.moduleID,
            sectionType: props.sectionType,
            subWindow: {
                body: aboutComponent,
                horizontalPos: `Center`,
                isDominant: false,
                moduleID: props.moduleID,
                subWindowKey: `aboutWindow`,
                title: `About`,
                verticalPos: `Center`,
            },
        };

        props.toggleSection(activeProps, activeSectionsComparer);
    };
    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.

    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            if (activeSections[i].sectionType === `aboutWindow`) {
                activeSections.splice(i, 1);
                i--;
            }
        }
        return activeSections;
    };

    const isActiveCSS: string = props.isActive ? `selected` : ``;

    return (
        <div className={`tab-section ${isActiveCSS}`} onClick={bindOnClick}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </div>
    );
};
